<template>
  <div class="d-flex">
    <InputText
      :model-value="model"
      type="search"
      :placeholder="placeholder"
      hide-details="auto"
      variant="filled"
      clearable
      @update:model-value="updateValue"
      @click:clear="clearValue"
    />
  </div>
</template>

<script setup lang="ts">
import InputText from '@/components/input-components/InputText.vue'

defineOptions({
  name: 'ToolbarSearchInput'
})

const emit = defineEmits<{
  (e: 'updateSearchInput', value: string): void
}>()

defineProps<{
  placeholder?: string
  searchInput?: string
}>()

const model = defineModel<string>({ default: '' })

const updateValue = (value: string) => {
  model.value = value
}

const clearValue = () => {
  model.value = ''
}
</script>
